import React from 'react'

const Badge = ({
  children,
  color,
  className,
  inverted = false,
  compact,
  ...rest
}) => {
  return (
    <span
      className={[
        'Badge',
        color,
        compact && 'compact',
        className,
        inverted && 'inverted'
      ]
        .filter((f) => !!f)
        .join(' ')}
      {...rest}
    >
      {children}
    </span>
  )
}

export default Badge
